
import { Api } from "./Api";

const ADMIN_URL=`/activity-logs`

  export const getReportsData = async (
    experience_id = 1,
    start_date = '2025-04-01',
    end_date = '2025-04-18',
  ) => {
    try {
      const response = await Api.get(`${ADMIN_URL}/get-activityLog`, {
        params: {
            experience_id,
            start_date,
            end_date,
          },
      });
      if (response.data && response.data.data) {
        return {
          reportsData:response.data.data || [],
          success:response.data.success
        };
      } else {
        console.error('Failed to fetch users: No Report Data found');
        return { reportsData: [],success:response.data.success};
      }
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 404) {
          console.warn('No users found (404). Returning empty report array.');
          
          return { reportsData: []};
        } else {
          console.error('Error fetching users:', error.response.data.message);
          return { error: error.response.data.message, reportsData: [] };
        }
      } else {
        console.error('Error fetching users:', error.message);
        return { error: 'An error occurred while trying to fetch users', reportsData: [] };
      }
    }
  };

